const WORDS = ["Granite", "Quartz", "Quartzite", "Marble", "Template", "Fabricate", "Install"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-6 font-display text-6xl italic sm:text-8xl lg:text-[9rem] ${i % 2 ? "ks-outline-text" : "text-[#F5F0E6]"}`}>{w}</span>
        <span className="h-3 w-3 rotate-45 bg-[#CDA85B]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section aria-label="Materials and services" data-testid="marquee" className="overflow-hidden bg-[#0B0F17] py-14 sm:py-20">
    <div className="ks-marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
